<template>
  <div :class="`custom-checkbox-dealer-${theme}`" @click="$emit('update:modelValue', isChecked)">
    <input
      :id="inputId"
      v-model="isChecked"
      type="checkbox"
      :name="inputId"
      :form="form"
      :required="required"
      @change="$emit('update:modelValue', isChecked)"
    />
    <label :for="inputId" class="font-weight-normal fs-4">
      {{ label }}
    </label>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, PropType } from 'vue'

export default defineComponent({
  props: {
    modelValue: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    validate: Boolean,
    label: String,
    required: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    form: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'primary'
    }
  },
  emits: ['update:modelValue'],
  setup(props) {
    const isChecked = ref(props.modelValue)
    const inputId = `checkbox-${Math.random().toString(36).substr(2, 9)}`

    return {
      isChecked,
      inputId
    }
  }
})
</script>
